import { inject, Injectable, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ScrollLockService {
  private readonly body = inject(DOCUMENT).body;
  private readonly renderer = inject(RendererFactory2).createRenderer(null, null);

  private originalPosition = '';
  private originalScrollStyle = '';
  private originalInset = '';
  private isScrollBlocked = false;

  lock(overflowStyleOverwrite?: string): void {
    if (this.isScrollBlocked) {
      return;
    }

    this.originalPosition = this.body.style.position;
    this.originalScrollStyle = overflowStyleOverwrite || this.body.style.overflow;

    this.renderer.setStyle(this.body, 'position', 'fixed');
    this.renderer.setStyle(this.body, 'overflow-y', 'scroll');
    this.renderer.setStyle(this.body, 'inset', '0');

    this.isScrollBlocked = true;
  }

  unlock(): void {
    if (!this.isScrollBlocked) {
      return;
    }

    this.restoreOrRemoveStyle('position', this.originalPosition);
    this.restoreOrRemoveStyle('overflow-y', this.originalScrollStyle);
    this.restoreOrRemoveStyle('inset', this.originalInset);
    this.isScrollBlocked = false;
  }

  restoreOrRemoveStyle(name: string, value: string): void {
    if (value) {
      this.renderer.setStyle(this.body, name, value);
    } else {
      this.renderer.removeStyle(this.body, name);
    }
  }
}
